export default function hydrateRecentInventoryActionCreator(userDuck, personalization) {
  return function (_temp) {
    let {
      withCounts = false
    } = _temp === void 0 ? {} : _temp;
    return async dispatch => {
      try {
        const inventory = await personalization.refreshInventoryCache();
        personalization.setInventoryCache(inventory);
        dispatch({
          type: userDuck.types.SET_RECENT_INVENTORY,
          payload: inventory
        });
        return inventory;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      return [];
    };
  };
}